import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import BugsnagPerformance from '@bugsnag/browser-performance'
import type { Event } from '@bugsnag/js'
import CustomError from '@/errors/CustomError'

const releaseStage = import.meta.env.VITE_NODE_ENV || 'development'

Bugsnag.start({
  apiKey: '201fb8136553a5aeb6f4005b41b3ff70',
  plugins: [new BugsnagPluginVue()],
  releaseStage,
  onError: (report: Event) => {
    if (report.originalError instanceof CustomError) {
      return false
    }
  }
})
BugsnagPerformance.start({ apiKey: '201fb8136553a5aeb6f4005b41b3ff70' })

const bugsnagVue = Bugsnag.getPlugin('vue')

export { Bugsnag, bugsnagVue }
